<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
    <g id="Nummer_1_bolletje" data-name="Nummer 1 bolletje" transform="translate(-727 -452)">
        <circle id="Ellipse_13" data-name="Ellipse 13" cx="13.5" cy="13.5" r="13.5" transform="translate(727 452)" fill="#0084c8"/>
        <text id="_1" data-name="1" transform="translate(737 471)" fill="#fff" font-size="16" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">1</tspan></text>
    </g>
</svg>
